<template>
    <div>
        <transition name="fade">
            <Row v-if="mainTable.sarchShow" :gutter="16">
                <Col span="24">
                    <search-card
                        :form="mainTable.searchForm"
                        :table-load-event="getTableRecords"
                        :table-search="mainTable.tableSearch"
                    />
                </Col>
            </Row>
        </transition>
        <Card :padding="0" :bordered="false" :dis-hover="true">
            <Row :gutter="16">
                <Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">总监角色部门列表</span>
                        </div>
                        <div class="right-bar">
                            <Button
                                v-if="$checkAccessArray(['S'])"
                                size="small"
                                class="btns"
                                shape="circle"
                                type="success"
                                icon="ios-add-circle-outline"
                                @click="onCreate"
                                >新增</Button
                            >
                            <Button
                                type="primary"
                                size="small"
                                class="btns"
                                shape="circle"
                                icon="ios-search"
                                @click="
                                    mainTable.sarchShow = !mainTable.sarchShow
                                "
                                >搜索</Button
                            >
                        </div>
                    </div>
                </Col>
            </Row>
            <Row :gutter="16">
                <Col span="24">
                    <stand-pagination-table
                        :columns="mainTable.columns"
                        :data="mainTable.data"
                        :extHeight="60"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getTableRecords"
                    />
                </Col>
            </Row>
        </Card>

        <RoleDeptInspectorEdit ref="roleDeptInspectorEdit" />
		<RoleDeptInspectorModal ref="roleDeptInspectorModal" />"
    </div>
</template>

<script>
import SearchCard from "@/components/searchCard/searchCard.vue";
import search from "@/libs/search";
import StandPaginationTable from "@/components/standard-pagination-table/StandPaginationTable";
import { statusNewFormat } from "@/libs/baseModelFormat";
import { dateRender } from "@/libs/tableRowTimeRender";
import RoleDeptInspectorEdit from "./role-dept-inspector-edit";
import {
    getRoleSeedFarmList,
    saveRoleSeedFarm
} from "@/api/modules/account-management/inspector-user-management";
import RoleDeptInspectorModal from "./components/role-dept-inspector-modal.vue";
export default {
    name: "RoleDeptInspectorList",
    components: {
        SearchCard,
        StandPaginationTable,
        RoleDeptInspectorEdit,
        RoleDeptInspectorModal
    },
    data() {
        return {
            mainTable: {
                columns: [
                    {
                        title: "行号",
                        type: "index",
                        width: 60,
                        align: "center"
                    },
                    {
                        title: "账号",
                        key: "userNames",
                        align: "center"
                    },
                    {
                        title: "角色名称",
                        key: "name",
                        align: "center"
                    },
                    {
                        title: "公司名称",
                        key: "projectCompany",
                        align: "center"
                    },
                    {
                        title: "部门名称",
                        key: "seedFarmName",
                        align: "center"
                    },
                    {
                        title: "状态",
                        key: "recordStatus",
                        align: "center",
                        render: (h, params) => {
                            return h("div", [
                                h(
                                    "span",
                                    {
                                        style: {
                                            color:
                                                params.row.recordStatus == 1
                                                    ? "#006400"
                                                    : "#FF0000"
                                        }
                                    },
                                    statusNewFormat(params.row.recordStatus)
                                )
                            ]);
                        }
                    },
                    {
                        title: "创建时间",
                        key: "createTime",
                        align: "center",
                        render: (h, params) =>
                            dateRender(h, params.row.createTime)
                    },
                    {
                        title: "更新时间",
                        key: "modifyTime",
                        align: "center",
                        render: (h, params) =>
                            dateRender(h, params.row.modifyTime)
                    },
                    {
                        title: "操作",
                        key: "action",
                        align: "center",
                        width: 80,
                        render: (h, params) => {
                            let btnText = params.row.recordStatus == 1 ? "停用" : "启用";
                            return h("div", [
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {
                                            color:
                                                params.row.recordStatus == 1
                                                    ? "#FF0000"
                                                    : "#006400"
                                        },
                                        on: {
                                            click: () => {
                                                this.onUpdate(params.row);
                                            }
                                        }
                                    },
                                    btnText
                                ),
                                h(
                                    "Button",
                                    {
                                        props: {
                                            type: "text",
                                            size: "small",
                                            shape: "circle"
                                        },
                                        style: {},
                                        on: {
                                            click: () => {
                                                this.edit(params.row);
                                            }
                                        }
                                    },
                                    "编辑"
                                )
                            ]);
                        }
                    }
                ],
                data: [],
                sarchShow: false,
                searchForm: [
                    {
                        label: "角色名称",
                        type: "Input",
                        value: "",
                        name: "name",
                        sql: "like"
                    },
                    {
                        label: "公司名称",
                        type: "Input",
                        value: "",
                        name: "projectCompany",
                        sql: "like"
                    },
                    {
                        label: "部门名称",
                        type: "Input",
                        value: "",
                        name: "seedFarmName",
                        sql: "like"
                    },
                    {
                        label: "状态",
                        type: "Select",
                        name: "roleSeedFarm.recordStatus",
                        sql: "in",
                        options: [
                            {
                                value: 1,
                                key: "启用"
                            },
                            {
                                value: 0,
                                key: "停用"
                            }
                        ]
                    }
                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    mounted() {
        this.getTableRecords();
    },
    methods: {
        getTableRecords(reset = false) {
            this.mainTable.loading = true;

            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            getRoleSeedFarmList(this.mainTable.tableSearch)
                .then(res => {
                    if (res.code === 0) {
                        this.mainTable.data = res.data.records;
                        search.globalSetFilterRecordCount(
                            this.mainTable.tableSearch,
                            res.data.filterRecordCount
                        );
                    }

                    this.mainTable.loading = false;
                })
                .catch(() => {
                    this.mainTable.loading = false;
                });
        },
        onCreate() {
            this.$refs.roleDeptInspectorEdit.showModal();
        },
        onUpdate(row) {
            let recordStatusInt = row.recordStatus == 0 ? 1 : 0;
            this.$Modal.confirm({
                title:
                    "当前状态为" + statusNewFormat(row.recordStatus) + ",是否变更为" + statusNewFormat(recordStatusInt) + "？",
                onOk: () => {
                    saveRoleSeedFarm({
                        roleSeedFarmUuid: row.roleSeedFarmUuid,
                        recordStatus: recordStatusInt
                    }).then(res => {
                        if (res.code === 0) {
                            this.getTableRecords();
                        }
                    });
                }
            });
        },
        edit(row){
            console.log("row", row);
            this.$refs.roleDeptInspectorModal.showModal("edit", row.roleId, row.projectCompany, row.seedFarmId, row.recordStatus);
        }
    }
};
</script>

<style scoped></style>
